import React from "react";
import { SectionCard } from "./SectionCard";
import { FieldRow } from "./FieldRow";
import { Textarea } from "./primitives";
import { submissionContent } from "./content";
import { debugArray } from "../../lib/debugArray";

export function FinalMessageSection() {
  const c = submissionContent.footer;

  return (
    <SectionCard title={c.messageTitle}>
      <FieldRow label="Message">
        <Textarea name="final_message" placeholder="Write your answer here..." />
      </FieldRow>

      <div className="min-w-0 break-words rounded-xl border border-indigo-200 bg-indigo-50 p-4 text-sm text-black">
        {debugArray("submit-final-message.lines", c.thankYou.split("\n")).map((line, idx) => (
          <div key={idx}>{line}</div>
        ))}
      </div>
    </SectionCard>
  );
}
